<template>
  <div>
    <div style="text-align:center;">
      <h1 class="title">{{ form.companyName }}</h1>

      <div style="height:40px;line-height:40px;background:#f3f3f3;margin-bottom:20px;">
        <span>发布时间: {{ form.publishDate| moment('YYYY-MM-DD') }}</span>
        <span>阅读量: {{ form.hits }}</span>
      </div>
    </div>
    <div style="min-height:200px;" v-html="form.brandIntroduce"></div>
  </div>
</template>

<script>
import { BrandAgricultureProductsDetails } from '@/api/main/BrandAgricultureProductsManager'
export default {
    data() {
        return {
            id: '',
            form: {
                id: null,
                title: '',
                tCode: null,
                orgId: null,
                publishTime: null,
                termOfValidity: null,
                infoContent: null,
                storageLocation: null,
                horsepower: null,
                iCode: null
            }
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
     loadData() {
       this.id = this.$route.query.id
       BrandAgricultureProductsDetails({ id: this.id }).then(res => {
        this.form = res.data
      })
     }
    }
}
</script>
<style scoped>
  span{
    margin-right: 15px;
  }
</style>
